import { reactive, type UnwrapNestedRefs } from 'vue';
import { updateMovieTags as updateMovieTagsHelper } from 'src/lib/moviePlayerHelper';
import type { GIMovie } from 'src/models/geoItem';
import type { MovieTag } from 'src/models/movie';
import type { MovieTagModalParams } from 'src/models';
import type {
  BothLeftRight,
  LeftRight,
  MoviePlayerCompareModeState,
} from 'src/models/moviePlayer';

interface Deps {
  pauseUI: (lr: BothLeftRight) => void;
}

interface MoviePlayerCompareModeTagModalContext {
  movieTagModal: MovieTagModalParams;
  startEditMovieTags: (lr: LeftRight) => Promise<void>;
  updateMovieTags: (resultTags: MovieTag[]) => void;
}

export function useMoviePlayerCompareModeTagModal(
  state: UnwrapNestedRefs<MoviePlayerCompareModeState>,
  deps: Deps,
): UnwrapNestedRefs<MoviePlayerCompareModeTagModalContext> {
  const movieTagModal = reactive<MovieTagModalParams>({ show: false, tags: [], movie: null });

  const startEditMovieTagsOfMovie = async(movie?: GIMovie | null) => {
    if (!movie) return;

    deps.pauseUI('left');
    deps.pauseUI('right');
    movieTagModal.movie = movie;
    movieTagModal.tags = movie.tags;
    movieTagModal.show = true;
  };
  const startEditMovieTags = async(lr: LeftRight) => {
    startEditMovieTagsOfMovie(state[lr].movieList.current.currentMovie);
  };
  const updateMovieTags = (resultTags: MovieTag[]) => {
    if (!movieTagModal.movie) return;

    updateMovieTagsHelper(resultTags, movieTagModal.movie);
    movieTagModal.show = false;
  };

  return reactive({ movieTagModal, startEditMovieTags, updateMovieTags });
}
